import { render } from "./send-status.vue?vue&type=template&id=05c6f58d&scoped=true"
import script from "./send-status.vue?vue&type=script&lang=js"
export * from "./send-status.vue?vue&type=script&lang=js"

import "./send-status.vue?vue&type=style&index=0&id=05c6f58d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c6f58d"]])

export default __exports__